<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header class="common-header" title="付款">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div v-if="pay_info">
            <div class="top-wrapper">
                <div class="row-wrapper title-wrapper">
                    <i class="iconfont">&#xe6d2;</i>
                    <label class="title">订单提交成功，请选择付款方式</label>
                </div>
                <div class="subtitle-wrapper">
                    <label class="subtitle">合计：</label>
                    <label class="price">￥{{pay_info.pay_amount}}{{pay_info.pay_mk>0 ? '+' + (pay_info.pay_mk*1) + '消费积分' : ''}}</label>
                </div>
            </div>
			<div class="main-content" v-if="pay_type!='pd_pay'">
				 <flex-line :show-border="true"><div><span>购物积分&nbsp;</span><span class="left-price">{{pay_info.member_available_pd}}</span></div><div slot="right"><mt-switch v-model="payment_info.pd_pay"></mt-switch></div></flex-line>
			</div>
			<div class="main-content" v-if="pay_type!='pd_pay'">
				<span class="subtitle">点击立即付款表示同意</span>
				<span class="price" style="font-size:0.7rem;" @click="onAgreement">《经销商协议》</span>
			</div>
            <div class="main-content" v-if="pay_type=='pd_pay'">
                <flex-line :show-border="true" @click.native="payType(index, item.payment_code)" v-for="(item,index) in payment_list" :key="index">
                    <div class="item-left-wrapper">
                        <i :class="setClass(item.payment_code)" ></i>
                        <label class="item-title">{{item.payment_name}}<lable v-if="item.payment_code == 'mk'"> 购物积分 {{pay_info.member_available_pd}}</lable></label>
                    </div>
                    <div slot="right" class="item-right-wrapper">
                        <i class="item-select iconfont" v-if="payment_info.payment_code == item.payment_code">&#xe69d;</i>
                    </div>					
                </flex-line>
            </div>
			
			<div class="user-avatar-wrapper" v-if="pay_type=='pd_pay'">
			  <div v-if="picurl" class="user-avatar">
			    <img :src="picurl" @click="openImage(picurl)">
			    <span @click="dropImage()" class="del-btn iconfont">&#xe6d8;</span>
			  </div>
			  <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage($event)">			    
			    <input type="file" accept="image/*">
				<div class="center-text">上传转账凭证</div>
			  </div>
			</div>
        </div>       
		<div class="bottom-wrapper">
		    <div class="common-btn ds-button-large" @click="submit()">{{pay_type=='pd_pay' ? '确认已打款': '立即付款'}}</div>
		</div>
		
		<!--展示转帐信息-->
		<mt-popup v-model="showpay" position="right" class="common-popup-wrapper">
		  <div class="common-header-wrap">
		    <mt-header :title="payment_info.payment_title" class="common-header">
		      <mt-button slot="left" icon="back" @click="showpay=false"></mt-button>
		    </mt-header>
		  </div>
		  <div class="common-popup-content">
		    <div class="main-content" v-if="payment_info.payment_index >= 0">
		    <flex-line class="field-line menu-item" :show-border="true">
				<span class="field-name">收款帐户</span>
				<div class="field-line-right" slot="right">
					<input class="field-input" :value="payment_list[payment_info.payment_index].payment.name"/>
					<div class="common-btn" @click="copy(payment_list[payment_info.payment_index].payment.name)">复 制</div>
				</div>
			</flex-line>
			<flex-line class="field-line menu-item" :show-border="true">
				<span class="field-name">收款帐号</span>				
				<div class="field-line-right" slot="right">
					<input class="field-input" :value="payment_list[payment_info.payment_index].payment.account"/>
					<div class="common-btn" @click="copy(payment_list[payment_info.payment_index].payment.account)">复 制</div>
				</div>
			</flex-line>
			<flex-line class="field-line menu-item" :show-border="true" v-if="payment_info.payment_code == 'bank'">
				<span class="field-name">开户行</span>
				<div class="field-line-right" slot="right">
					<input class="field-input" :value="payment_list[payment_info.payment_index].payment.bank"/>
					<div class="common-btn" @click="copy(payment_list[payment_info.payment_index].payment.bank)">复 制</div>
				</div>
			</flex-line>
			
			<div class="qrcode-pic" v-if="payment_list[payment_info.payment_index].payment.qrcode != ''">
			  <img :src="payment_list[payment_info.payment_index].payment.qrcode"/>
			</div>
			
			</div>
		  </div>
		</mt-popup>
		
		<!--裁剪图片-->
		<mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
		  <div class="common-header-wrap">
		    <mt-header title="裁剪图片" class="common-header">
		      <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
		      <div class="common-btn btn" slot="right" @click="useCrop">使用</div>
		    </mt-header>
		  </div>
		  <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
		</mt-popup>
		
		<!--图片预览-->
		<mt-popup v-model="isshow" popup-transition="popup-fade" class="popup" >
		  <img :src="showimage" :style="getBannerStyle" @click="isshow=false">
		</mt-popup>
    </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'	
import { getStoreJoinin } from '../../../api/seller'
import { getOrderpayInfo } from '../../../api/memberBuy'
import { getVrOrderpayInfo } from '../../../api/memberVrBuy'
import { mapState } from 'vuex'
import { pay, getPaymentList } from '../../../api/memberPayment'
import { getRechargeInfo } from '../../../api/memberRecharge'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import { loadScript } from '../../../util/common'
import { isWechat } from '../../../util/wechat'
import { uploadInfoFile} from '../../../api/seller'
import flexLine from '../../flexLine'
import Clipboard from 'clipboard'
export default {
  name: 'pay', 
  data () {
    return {
	  cropperOption: {
	    img: '',
	    canMove: false,
	    autoCrop: true,
	    autoCropWidth: 100,
	    autoCropHeight: 100,
	    maxImgSize: 500,
	    outputType: 'png'
	  },
	  showCrop: false,
	  picurl:'',
	  showimage:'',
	  isshow:false,
	  
      uniapp: 0,
      pay_sn: this.$route.query.pay_sn ? this.$route.query.pay_sn : '',
      pay_type: this.$route.query.pay_type ? this.$route.query.pay_type : '',
      // 订单支付显示的数据
      pay_info: null,
      // 提交支付需要用到的数据
      payment_info: {
        password: '',
        rcb_pay: false,
        pd_pay: false,
		pic:'',
		payment_title:'',
		payment_index: -1,
        payment_code: ''
      },
      payment_list: [],	  
      showNotice: 0,
      notice: this.$route.query.notice,
      ifLoaded: 0,
	  showpay:false,
    }
  },
  components: {
    flexLine,
	VueCropper
  },
  computed: {
    ...mapState({
      token: state => state.member.token
    }),
	getBannerStyle: function () {
	  const { width, height } = window.screen
	  let itemWidth = width
	  let itemHeight = height
	  return {
	    maxWidth: itemWidth + 'px',
	    maxHeight: itemHeight + 'px'
	  }
	}
  },
  created: function () {
    /*let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      _this.ifLoaded++
    })
    loadScript('weixin', 'https://res.wx.qq.com/open/js/jweixin-1.3.2.js', function () {
      _this.ifLoaded++
    })*/
    this.getMemberPayInfo()
  },
  watch: {
    showNotice: function (val) {
      if (val && this.notice) {
        MessageBox.confirm('如果您已完成支付，请点击“完成付款”按钮，如果您未完成支付，请点击“重新支付”重新发起支付', '确认支付是否完成', { cancelButtonText: '重新支付', confirmButtonText: '完成付款' }).then(action => {
          this.goNext()
        })
      }
    },
    ifLoaded: function (val) {
      if (val >= 2) {
        this.getPaymentList()
      }
    }
  },
  methods: {
    goBack () {
      if (this.notice) {
        this.$router.go(-2)
      } else {
        this.$router.go(-1)
      }
    },
    setClass (code) {
      let obj = {}
      obj['icon ' + code] = true
      return obj
    },
	onAgreement () {
	  this.$router.push({
	    name: 'HomeDocument',
	    query: { type: 'shopbuy' }
	  })
	},
    goNext () {
      if (this.pay_type === 'pay_new') {
        this.$router.push({ name: 'MemberOrderList' })
      } else if (this.pay_type === 'vr_pay_new') {
        this.$router.push({ name: 'MemberVrOrderList' })
	  } else if (this.pay_type === 'sj_pay') {
	    this.$router.push({ name: 'HomeSellerLogin' })
      } else if (this.pay_type === 'pd_pay') {
        this.$router.push({ name: 'MemberRechargeList' })
      }
    },
    payType (index, code) {
	   this.payment_info.payment_index = index
       this.payment_info.payment_code  = code
	   
	   if(code == 'bank')
	      this.payment_info.payment_title = '商家银行卡收款信息';
	   else if(code == 'alipay')
	      this.payment_info.payment_title = '商家支付宝收款信息';
	   else if(code == 'wx')
	      this.payment_info.payment_title = '商家微信收款信息';
	   	   
	    this.showpay = code != 'mk' && code !='facepay';
    },
    getPaymentList () {
      /*let _this = this
      var from = ''
      var code = ''
      if(isWechat()){
          code = 'wxpay_jsapi'
        }
      //uni.getEnv(function (res) {
        //if (res.plus) {
        //  from = 'app'
        //}
      //})
      wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) {
      code = 'wxpay_minipro'
      }
      })
      getPaymentList(from,code).then(res => {
        this.payment_list = res.result.payment_list
        if (this.payment_list.length) {
          this.payment_info.payment_code = this.payment_list[0].payment_code
        }
      }).catch(function (error) {
        Toast(error.message)
      })*/
    },
    getMemberPayInfo () {
      if (this.pay_type === 'pay_new') {
        let _this = this
        getOrderpayInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.pay_info
			this.payment_list = this.pay_info.payment_list
			if (this.payment_list.length) {
			  this.payment_info.payment_code = this.payment_list[0].payment_code
			}
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'vr_pay_new') {
          let _this = this
          getVrOrderpayInfo(
              this.pay_sn
          ).then((res) => {
              if (res.code === 10000) {
                  this.pay_info = res.result.pay_info
              }
              this.showNotice = 1
          }).catch(function (error) {
              if (error.code === 12001) { // 订单已经支付
                  _this.goNext()
              } else {
                  Toast(error.message)
              }
          })
      } else if (this.pay_type === 'sj_pay') {
        let _this = this
          getStoreJoinin().then((res) => {
          if (res.code === 10000) {
            this.pay_info = res.result.store_joinin
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      } else if (this.pay_type === 'pd_pay') {
        getRechargeInfo(
          this.pay_sn
        ).then((res) => {
          if (res.code === 10000) {
            this.pay_info = { pay_amount: res.result.pdinfo.pdr_amount }
			this.payment_list = res.result.payment_list
			if (this.payment_list.length) {
			  this.payment_info.payment_code = this.payment_list[0].payment_code
			}
          }
          this.showNotice = 1
        }).catch(function (error) {
          if (error.code === 12001) { // 订单已经支付
            _this.goNext()
          } else {
            Toast(error.message)
          }
        })
      }
    },
	copy(tex) {
	  let _this = this
	  let clip = new Clipboard('.common-btn', {
        text: () => {
          return tex
        }
      })
	  //复制成功
	  clip.on('success', function() {
		  Toast('复制成功！')
		  clip.destroy()
	  });
	  //复制失败
	  clip.on('error', function() {
	      Toast('复制失败,请手动复制！')
	      clip.destroy()
	  });
	},
	openImage (src) {
	  this.showimage = src
	  this.isshow = true
	},
	dropImage () {
	  this.picurl = ''
	  this.payment_info.pic = ''
	  this.$forceUpdate()
	},
	useCrop () {
	  this.$refs.cropper.getCropBlob(res => {
	    let files = new window.File([res], 'temp.png', { type: res.type })
	    let formdata = new FormData()
	
	    formdata.append('file', files)
	    formdata.append('name', 'file')
	
	    uploadInfoFile(formdata).then(res => {	      
	      this.picurl = res.result.url
		  this.payment_info.pic = res.result.path
	      this.showCrop = false
	      Indicator.close()
	      this.$forceUpdate()
	    }).catch(function (error) {
	      Toast(error.message)
	      Indicator.close()
	    })
	  })
	},
	uploadImage (event) {
	  let that = this
	  let file = event.target.files[0]
	  let reader = new FileReader()
	  let rs = reader.readAsDataURL(file)
	  reader.onload = (e) => {
	    that.cropperOption.img = e.target.result
	    let image = new Image()
	    image.src = e.target.result
	    image.onload = function () {
	      that.cropperOption.autoCropWidth = window.screen.width
	      that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
	      that.cropperOption.maxImgSize = window.screen.height - 40
	      that.showCrop = true
	      that.$forceUpdate()
	    }
	  }
	},
    submit () {
      //if (this.ifLoaded < 2) {
      //  Toast('请等待文件加载完成')
      //  return
      //}
      let _this = this
      //uni.getEnv(function (res) {
        //if (res.plus) {
        //  _this.uniapp = 1
        //}
      //})	  
	  if(this.pay_type != 'pd_pay')
	  {
		 if(this.payment_info.pd_pay == false)
		 {
			  Toast('请选择购物积分支付')
			  return;
		 }		 
		 if (!this.pay_info.member_paypwd) {
		   MessageBox.confirm('您需要先去设置安全码', '').then(action => {
		     this.$router.push({ name: 'MemberSetting' })
		   })
		   return;
		 }
		 else if(!this.payment_info.password)
		 {
			 MessageBox.prompt('<b>请输入安全码</b>', '', {
			   showCancelButton: true,
			   inputType: 'password'
			 }).then(({ value, action }) => {
			   this.payment_info.password = value
			   this.submit()
			 })
			 return;
		 }
		 this.payment_info.payment_code = 'mk';
	  }
	  else if((this.picurl == '' && this.payment_info.payment_code != 'facepay') || this.payment_info.payment_code == '')
	  {
		  if(this.payment_info.payment_code != 'facepay')
		  {
		  this.picurl == '' ? Toast('未上传转帐凭证,操作错误!') : Toast('未选择支付类型,操作错误!') ;
		  return;
		  }
	  }
      
      //var param = 'action=' + this.pay_type + '&key=' + this.token + '&pay_sn=' + this.pay_sn + '&password=' + this.payment_info.password + '&rcb_pay=' + this.payment_info.rcb_pay + '&pd_pay=' + this.payment_info.pd_pay + '&payment_code=' + this.payment_info.payment_code
      //if (this.payment_info.payment_code == 'wxpay_minipro') {
      //  wx.miniProgram.redirectTo({ url: '../pay/pay?' + param })
      //  return
      //}
      //if (this.uniapp) {
      //  uni.redirectTo({ url: 'pay?' + param })
      //  return
      //}
      pay(
        this.pay_sn, this.pay_type, this.payment_info, this.token, this.uniapp
      ).then((res) => {
        if (res.code) {
          if (res.code === 10000 || res.code === 12001){
            this.goNext()
          } else {
			this.payment_info.password = ''
            Toast(res.message)
          }
        } else {
          document.write(res)
        }
      }).catch(function (error) {
        if (error.message) {
          Toast(error.message)
        } else {
          document.write(error)
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
    .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: $mainbgColor;
    }
    .bottom-wrapper{background: #fff;position: absolute;width:100%;padding:.5rem $pageSpace;box-sizing: border-box;bottom:0;left:0;}
    .main-content{padding:0 $pageSpace;background: #fff}
    .top-wrapper {
        padding:0 $pageSpace;
        height: 5rem;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
        margin-bottom: 0.75rem;
    }
    .row-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
    }
    .title-wrapper {
        height: 3.2rem;
        i{font-size:$mainFontSize;margin-right: .2rem; }
    }
    .subtitle-wrapper {
        height: 1.5rem;
        text-align: right;
    }
    .icon {
        width: 1.2rem;
        height: 1.2rem;
        font-size:1.2rem;
        margin-right: 0.5rem;
    }
    .title {
        font-size:$subFontSize;
        color: $formInputColor;
        font-weight: 700;
    }
    .subtitle {
        font-size:$subFontSize;
        color:$descTextColor;
    }
    .price {
        font-size:$h2;
        color: $primaryColor;
        font-weight: 700;
    }
    .left-price{        
        color: #48A1FB;
    }
    .item-wrapper{
        height: 3.1rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
        border-bottom: 1px solid $lineColor;
    }
    .item-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: stretch;
        background-color: #fff;
    }
    .item-left-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        i{background-image: url(../../../assets/image/wxpayicon.png);background-repeat: no-repeat;background-size: 100%;}
        .alipay,.alipay_h5,.alipay_app{background-image: url(../../../assets/image/alipayicon.png);}
        .bank,.unionpay_h5{background-image: url(../../../assets/image/unionpayicon.png);}
		.mk{background-image: url(../../../assets/image/mk.png);}
		.facepay{background-image: url(../../../assets/image/facepay.png);}
    }
    .item-right-wrapper {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
    }
    .item-title {
    }
    .item-subtitle {
        font-size:$h2;
        color: #8C8C8C;
        margin-right:0.25rem;
        text-align: right;
    }
    .item-select {
        font-size: 1.2rem;
        color:#7ED321;
    }
    .indicator {
        width: 0.7rem;
        height: 0.7rem;
        margin-left:0.25rem;
        margin-right: 0.8rem;
    }
    .action-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 2.5rem;
        margin-top: 2.25rem;
    }
	.common-btn{color:#fff; background:#f00;border-radius:0.2rem; margin-left:0.2rem;}
	.qrcode-pic img{width:100%;}
	.user-avatar-wrapper{padding:2rem 0}
	.user-avatar {
		flex:1;
		border:1px solid #eee;
		background:#fff;
		position: relative;
		width: 5rem;
		height: 5rem;
		margin: 0 auto;
		text-align: center;
		img {
			width: 100%;
			height: 100%
		}
		input {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			opacity: 0
		}
		.center-text{padding-top:5.5rem;font-size:$subFontSize;font-weight:bold;}
	}
	.user-avatar::before {
		position: absolute;
		font-size: 1.5rem;
		line-height: 5rem;
		left: 50%;
		margin-left: -.75rem;
		color: rgba(0, 0, 0, 0.5)
	}
</style>